(function() {
    angular.module('tmx-app').controller('organizationPortfolioReportCtrl', [
        '$mdSidenav',
        'tmxUtility',
        'menu',
        '$mdMedia',
        'ReportService',
        'resolvedData','ToastService',

        function organizationPortfolioReportCtrl(
            $mdSidenav,
            tmxUtility,
            menu,
            $mdMedia,
            ReportService,
            resolvedData,
            ToastService
        ) {
            var organizationPortfolioReportVM = this;
            organizationPortfolioReportVM.menu = menu;
            organizationPortfolioReportVM.gridData = new kendo.data.ObservableArray([]);
            organizationPortfolioReportVM.search = search;
            organizationPortfolioReportVM.toggle = toggle;
            organizationPortfolioReportVM.isOpen = isOpen;
            organizationPortfolioReportVM.SAStatuses=[{HiddenValue: -1, VisibleValue: "All"}];
            organizationPortfolioReportVM.Organizations= [{HiddenValue: -1, VisibleValue: "All"} ];
            organizationPortfolioReportVM.clear = clear;
            organizationPortfolioReportVM.formatColumnName = tmxUtility.formatColumnName;
            organizationPortfolioReportVM.formatAmount= tmxUtility.formatAmount;
            organizationPortfolioReportVM.formatDate=function(date){
                let parts=date.split('/');
                var mydate = new Date(parts[1], parts[0]);
                return mydate.toLocaleString('default', { month: 'short',year: "numeric" });
            };

            (function InitializePage() {
                if (tmxUtility.exists(resolvedData)) {
                    organizationPortfolioReportVM.SAStatuses.push(...resolvedData.SAStatuses.map(x => { return { HiddenValue: x.LookupId, VisibleValue: x.VisibleValue } }));
                    var orgs=resolvedData.Organizations.Data.map(x => { return { HiddenValue: x.OrganizationId, VisibleValue: x.OrganizationName } });
                    organizationPortfolioReportVM.Organizations.push(...orgs);
                }
            })();

            function isOpen(navID) {
                return $mdSidenav(navID).isOpen();
            }

            function clear() {
                organizationPortfolioReportVM.ToDate = undefined;
                organizationPortfolioReportVM.FromDate = undefined;
                organizationPortfolioReportVM.StatusId=undefined;
                organizationPortfolioReportVM.OrgId=undefined;


            }


            function toggle() {
                $mdSidenav("ExportSideNav")
                    .toggle()
                    .then(function() {});
            }

            organizationPortfolioReportVM.exportToPdf = exportToPdf;

            function search() {
                organizationPortfolioReportVM.container.organizationPortfolioReport.dataSource.read();
                
            }

            function exportToPdf() {

                if (organizationPortfolioReportVM.dialogForm.$valid){
                   
                    ReportService.ReportPDF({ StoredProcedure: 'sp_organization_portfolio_report', ReportName: 'Organization_Portfolio_Report', Orientation: 'Portrait', 
                        Arguments: { StartDate:organizationPortfolioReportVM.FromDate,
                            EndDate:organizationPortfolioReportVM.ToDate,
                            OrganizationId: organizationPortfolioReportVM.OrgId>0 ? organizationPortfolioReportVM.OrgId : undefined ,
                            StatusLkp : organizationPortfolioReportVM.StatusId>0 ? organizationPortfolioReportVM.StatusId : undefined , } });
                }
                else{
                    ToastService.showCustomToast("default", "Required fields are missing");
                }
            }


            var gridColumns = [{
                field: tmxUtility.formatColumnName('OrganizationCode'),
                title: "Organization Code",
                type: "text",
                scrollable: false,
                search: true,
                headerTemplate: "<span>Organization Code</span>"
            },
            {
                field: tmxUtility.formatColumnName('OrganizationName'),
                title: "Organization Name",
                type: "text",
                scrollable: false,
                search: true,
                headerTemplate: "<span>Organization Name</span>"
            },
            {
                field: tmxUtility.formatColumnName('TotalCustomer'),
                title: "Total Customer",
                type: "text",
                scrollable: false,
                search: true,
                template: "{{OrganizationPortfolioReportCtrl.formatAmount(dataItem[OrganizationPortfolioReportCtrl.formatColumnName('TotalCustomer')])}}",
                headerTemplate: "<span>Total Customer</span>"
            },
            {
                field: tmxUtility.formatColumnName('TotalAdvance'),
                title: "Total Advance",
                type: "text",
                scrollable: false,
                search: true,
                template: "{{OrganizationPortfolioReportCtrl.formatAmount(dataItem[OrganizationPortfolioReportCtrl.formatColumnName('TotalAdvance')])}}",
                headerTemplate: "<span>Total Advance</span>"
            },
            {
                field: tmxUtility.formatColumnName('TotalSalary'),
                title: "Total Salary",
                type: "text",
                scrollable: false,
                search: true,
                template: "{{OrganizationPortfolioReportCtrl.formatAmount(dataItem[OrganizationPortfolioReportCtrl.formatColumnName('TotalSalary')])}}",
                headerTemplate: "<span>Total Salary</span>"
            },
            {
                field: tmxUtility.formatColumnName('TotalServiceFees'),
                title: "Total Service Fees",
                type: "text",
                scrollable: false,
                search: true,
                template: "{{OrganizationPortfolioReportCtrl.formatAmount(dataItem[OrganizationPortfolioReportCtrl.formatColumnName('TotalServiceFees')])}}",
                headerTemplate: "<span>Total Service Fees</span>"
            },
            {
                field: tmxUtility.formatColumnName('period'),
                title: "Period",
                type: "text",
                scrollable: false,
                search: true,
                template: "{{OrganizationPortfolioReportCtrl.formatDate(dataItem[OrganizationPortfolioReportCtrl.formatColumnName('period')])}}",
                headerTemplate: "<span>Period</span>"
            },
                
            ];


            organizationPortfolioReportVM.mainGridOptions = {
                autoBind:false,
                dataSource: {
                    transport: {
                        read: function(o) {
                            
                            var objArgs = {
                                StartDate:organizationPortfolioReportVM.FromDate,
                                EndDate:organizationPortfolioReportVM.ToDate,
                                OrganizationId: organizationPortfolioReportVM.OrgId>0 ? organizationPortfolioReportVM.OrgId : undefined ,
                                StatusLkp : organizationPortfolioReportVM.StatusId>0 ? organizationPortfolioReportVM.StatusId : undefined ,
                                
                            }; 

                            var filters = {
                                "StoredProcedure": "sp_organization_portfolio_report",
                                "Arguments": objArgs,
                                "ReportName": "Organization_Portfolio_Report"
                            };

                            firebase.logTmxEvent('report', { name: 'Organization Portfolio Report' });
                            ReportService.putByParams(o, true, "ReportDataSourceResultPost", filters).then(function(response) {

                                if (response) {
                                    organizationPortfolioReportVM.GridResponseData = response.Data;
                                    o.success(response);
                                }
                            });
                            
                        },

                        dataType: "json"
                    },
                    schema: {
                        data: "data",
                        total: "data.length",
                    },
                    serverPaging: false,
                    serverFiltering: false,
                    serverSorting: false
                },
                pageable: {
                    refresh: true,
                    pageSizes: [5, 10, 15, 20, 100, "All"],
                    pageSize: 20,
                    buttonCount: 4
                },
                excel: {
                    allPages: true,
                    fileName: "OrganizationPortfolioReport.xlsx"
                },
                excelExport: function(e) {
                    var sheet = e.workbook.sheets[0];
                    var columns = e.workbook.sheets[0].columns;
                    for (var rowIndex = 1; rowIndex < sheet.rows.length; rowIndex++) {

                        //var row = sheet.rows[rowIndex];
                    }
                    columns.forEach(function(column) {
                        delete column.width;
                        column.autoWidth = true;
                    });
                },
                sortable: true,
                scrollable: !$mdMedia("gt-sm"),

                columns: gridColumns
            };

            
        }
    ]);
})();